<template>
  <div>
    <CalendarMeeting />
  </div>
</template>

<script setup>
import CalendarMeeting from '@/components/CalendarMeeting.vue';

</script>

<style></style>
